export default {
  methods: {
    getSessionId() {
      this.$store.dispatch('common/actionApiGetSessionId').catch(error => {
        console.error('Error fetching session ID:', error)
      })
    },
  },
}
